import React, { useEffect } from 'react';
import './IntroBanner.css';
import Background from '../../components/Background/Background';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Header() {

  useEffect(() => {

    AOS.init({
      duration: 1000,
      once: true,
    });

  }, []);

  return (
    <Background backgroundOpacity={0.3} background='black' z_index="100" videoSrc="./video/dog-run.mp4">
      <section id="intro-banner">
        <div data-aos="fade-up" className="content-wrapper">
          <div className="logo-container">
            <img src="./img/pokelu.svg" alt="Logo de Pokélu" loading="lazy" />
          </div>
          <h1 className="header-title">
          Pokélu - Remplacement d'élevage/pension - Éducation comportement chat/chien 
          </h1>
        </div>
      </section>
    </Background>
  );
}

export default Header;